const SquareChatIcon = (props) => {
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8.83366 12.5003L6.27095 15.0951C5.91348 15.457 5.73475 15.638 5.58112 15.6507C5.44784 15.6618 5.31734 15.6082 5.23029 15.5067C5.12996 15.3897 5.12996 15.1353 5.12996 14.6266V13.3267C5.12996 12.8703 4.75622 12.5401 4.30466 12.4739V12.4739C3.21178 12.3138 2.35347 11.4555 2.19339 10.3627C2.16699 10.1825 2.16699 9.96742 2.16699 9.53736V5.66699C2.16699 4.26686 2.16699 3.5668 2.43948 3.03202C2.67916 2.56161 3.06161 2.17916 3.53202 1.93948C4.0668 1.66699 4.76686 1.66699 6.16699 1.66699H12.3337C13.7338 1.66699 14.4339 1.66699 14.9686 1.93948C15.439 2.17916 15.8215 2.56161 16.0612 3.03202C16.3337 3.5668 16.3337 4.26686 16.3337 5.66699V9.16699M16.3337 18.3337L14.52 17.0727C14.265 16.8955 14.1376 16.8069 13.9988 16.744C13.8757 16.6882 13.7462 16.6477 13.6133 16.6232C13.4635 16.5956 13.3083 16.5956 12.9978 16.5956H11.5003C10.5669 16.5956 10.1002 16.5956 9.74368 16.4139C9.43007 16.2541 9.1751 15.9992 9.01532 15.6855C8.83366 15.329 8.83366 14.8623 8.83366 13.9289V11.8337C8.83366 10.9002 8.83366 10.4335 9.01532 10.077C9.1751 9.76341 9.43007 9.50844 9.74368 9.34865C10.1002 9.16699 10.5669 9.16699 11.5003 9.16699H16.167C17.1004 9.16699 17.5671 9.16699 17.9236 9.34865C18.2372 9.50844 18.4922 9.76341 18.652 10.077C18.8337 10.4335 18.8337 10.9002 18.8337 11.8337V14.0956C18.8337 14.8721 18.8337 15.2604 18.7068 15.5667C18.5376 15.9751 18.2132 16.2995 17.8048 16.4687C17.4985 16.5956 17.1102 16.5956 16.3337 16.5956V18.3337Z"
        stroke="#444CE7"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default SquareChatIcon
